// config.js

const INIT_SEEDS_COUNT = 7;
const HOLE_NUMBERS = INIT_SEEDS_COUNT*2;
const MIN_INDEX_UPPER = 0;
const POS_MULTIPLIER = 0.6;
const VERTICAL_POS_UPPER = -0.4;
const VERTICAL_POS_LOWER = 0.65;
const ANIMATION_DELAY = 350;
const CAPTURE_ANIMATION_DELAY = 350;
const CONTINUE_SOWING_DELAY = 200;
const INITIAL_DELAY = 350;

const config = {
    PLAYER_UPPER: 'UPPER',
    PLAYER_LOWER: 'LOWER',
    INIT_SEEDS_COUNT: INIT_SEEDS_COUNT,
    HOLE_NUMBERS: HOLE_NUMBERS,
    MIN_INDEX_LOWER: INIT_SEEDS_COUNT, // 7
    MAX_INDEX_LOWER: HOLE_NUMBERS - 1, // 13
    MIN_INDEX_UPPER: MIN_INDEX_UPPER, // 0
    MAX_INDEX_UPPER: INIT_SEEDS_COUNT - 1, // 6
    POS_MULTIPLIER: POS_MULTIPLIER,
    VERTICAL_POS_UPPER: VERTICAL_POS_UPPER,
    VERTICAL_POS_LOWER: VERTICAL_POS_LOWER,
    ANIMATION_DELAY: ANIMATION_DELAY,
    CAPTURE_ANIMATION_DELAY: CAPTURE_ANIMATION_DELAY,
    CONTINUE_SOWING_DELAY: CONTINUE_SOWING_DELAY,
    INITIAL_DELAY: INITIAL_DELAY,
}

export default config;